import React, { useState } from "react";

import logo from "../../assets/images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { forgotPassword } from "../../api/server";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { ThreeDots } from "react-loader-spinner";
import "./forgotPassword.css";

const ForgotPassword = () => {
  const [postLoading, setPostLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const isError = feedback?.type === "error";
  const closeFeedback = () => setShowFeedback(false);
  const showMessage = (message) => {
    setFeedback(message);
    setShowFeedback(true);
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Your Email is required"),
  });
  const {
    handleChange,
    touched,
    values,
    errors,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: { email: "" },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setPostLoading(true);
      setFeedback(null);
      try {
        const res = await forgotPassword(values);
        if (res.status === 200) {
          resetForm();
          showMessage({
            type: "success",
            message: res.data.message || "A password reset link has been sent to your email.",
          });
        } else {
          showMessage({ type: "error", message: "We couldn’t send the reset link. Please try again." });
        }
      } catch (err) {
        const message = err.response?.data?.error || err.response?.data?.message;
        showMessage({
          type: "error",
          message: typeof message === "string" ? message : "We couldn’t send the reset link. Please try again.",
        });
      } finally {
        setPostLoading(false);
      }
    },
  });
  return (
    <div>
      <section className="login_wrap">
        <div className="info_login_content">
          <div className="content_login">
            <h1>Your path <span style={{textTransform:'lowercase'}}>to</span> financial recovery!</h1>
          </div>
        </div>
        <div className="login_form w-100">
          <div
            className="content_login_form w-100"
            style={{ maxWidth: "500px" }}
          >
            <div className="login_logo">
              <Link to={`/`}>
                <img src={logo} alt="logo" />
              </Link>
              <p className="f18">Please enter your Email</p>
            </div>

            <div className="mt-60">
              <form onSubmit={handleSubmit}>
                <div className=" input_wrap ">
                  <label className="label-title" htmlFor="forgot-password-email">Email</label>
                  <input
                    id="forgot-password-email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="email"
                    value={values.email}
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                  />
                  {errors.email && touched.email ? (
                    <p className="text-danger">{errors.email}</p>
                  ) : null}
                </div>

                <button
                  className="btn_brnd mt-4 me-3  login_btn"
                  type="submit"
                  disabled={postLoading}
                >
                  {postLoading ? (
                    <ThreeDots
                      height="20"
                      width="60"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{
                        display: "block",
                      }}
                      wrapperClassName="spinner"
                      visible={true}
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Modal
        show={showFeedback}
        onHide={closeFeedback}
        onExited={() => setFeedback(null)}
        centered
        className={`password-reset-confirmation${isError ? " password-reset-confirmation--error" : ""}`}
        backdropClassName="password-reset-backdrop"
        aria-labelledby="password-reset-confirmation-title"
        aria-describedby="password-reset-confirmation-description"
      >
        <Modal.Header closeButton closeLabel="Close message" />
        <Modal.Body>
          <div className="password-reset-confirmation__icon" aria-hidden="true">
            <i className={`fa-solid ${isError ? "fa-circle-exclamation" : "fa-envelope-circle-check"}`} />
          </div>
          <h2 id="password-reset-confirmation-title">{isError ? "Unable to send reset link" : "Check your email"}</h2>
          <p id="password-reset-confirmation-description">
            {feedback?.message}
          </p>
          <div className="password-reset-confirmation__hint">
            {isError
              ? "Check your email address and try again."
              : "Don’t see it yet? Check your spam or junk folder, or allow a few minutes for it to arrive."}
          </div>
          <button type="button" className="password-reset-confirmation__done" onClick={closeFeedback}>
            {isError ? "Try again" : "Got it"}
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ForgotPassword;
